import { useEffect, useRef } from "react";

const isInAppBrowser = () => {
  if (typeof navigator === "undefined") return false;
  return /FBAN|FBAV|Instagram|Messenger/i.test(navigator.userAgent);
};

export const useCourtTTSAlert = ({ active, court }) => {
  const intervalRef = useRef(null);
  const volumeRef = useRef(0.4);

  const synth =
    typeof window !== "undefined" && window.speechSynthesis
      ? window.speechSynthesis
      : null;

  const stop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (synth?.cancel) {
      synth.cancel();
    }

    volumeRef.current = 0.4;
  };

  useEffect(() => {
    if (!active || !court) {
      stop();
      return;
    }

    // 🚫 Disable TTS in Messenger / IG / FB browsers
    if (isInAppBrowser() || !synth || !window.SpeechSynthesisUtterance) {
      if (navigator.vibrate) {
        navigator.vibrate([300, 150, 300]);
      }
      return;
    }

    const speak = () => {
      if (!synth?.speak || !synth?.cancel) return;

      synth.cancel();

      const utterance = new SpeechSynthesisUtterance(
        `You are now playing. Please proceed to court ${court}.`
      );

      utterance.lang = "en-PH";
      utterance.rate = 0.95;
      utterance.pitch = 1;
      utterance.volume = Math.min(volumeRef.current, 1);

      synth.speak(utterance);

      if (navigator.vibrate) {
        navigator.vibrate([200, 100, 200]);
      }

      volumeRef.current = Math.min(volumeRef.current + 0.15, 1);
    };

    speak();
    intervalRef.current = setInterval(speak, 5000);

    return stop;
  }, [active, court]);

  return stop;
};
